import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { SharedModule } from './components/shared.module';

const routes: Routes = [
    { path: '', loadChildren: './pages/main/tabs/tabs.module#TabsPageModule', canActivate: [AuthGuardService] },
    { path: 'login', loadChildren: './pages/login/login.module#LoginPageModule' },

    //{ path: 'main/service/new-service/:Ledger/:TimeStamp', loadChildren: './pages/main/service/new-service/new-service.module#NewServicePageModule' },
    //{ path: 'main/service/manage-service/:ServiceJobID', loadChildren: './pages/main/service/manage-service/manage-service.module#ManageServicePageModule' },
    //{ path: 'main/stock/item-detail/:ItemID', loadChildren: './pages/main/stock/item-detail/item-detail.module#ItemDetailPageModule' },
    //{ path: 'main/stock/manage-parts-sale/:ID', loadChildren: './pages/main/stock/manage-parts-sale/manage-parts-sale.module#ManagePartsSalePageModule' },
    //{ path: 'main/stock/manage-parts-sale/:ID/:Ledger/:TimeStamp', loadChildren: './pages/main/stock/manage-parts-sale/manage-parts-sale.module#ManagePartsSalePageModule' },
    //{ path: 'dashboard', loadChildren: './pages/main/vehicle_sales/dashboard/dashboard.module#DashboardPageModule' },
];

@NgModule({
    providers: [AuthGuardService],
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
        SharedModule
    ],
    exports: [RouterModule, SharedModule]
})
export class AppRoutingModule { }
